import * as Types from '../actions/types';
import * as Constant from 'common/Constant';

let initialState = {
  favoriteReports: [],
  topFavorites: [],
  currentMenu: { name: Constant.ALL },
  selectedLegacyTags: [],
  favoritesLoading: false,
  topFavoritesLoading: false
};

export default function favoriteReportReducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_REPORT_BY_USER_ID_REQUEST:
      return {
        ...state,
        favoritesLoading: true
      };
    case Types.GET_REPORT_BY_USER_ID_SUCCESS:
      return {
        ...state,
        favoriteReports: (Array.isArray(action.data) ? action.data : []).map((item, indx) => ({ ...item, createdDttm: item?.createdDttm ?? (Date.now() - indx) })),
        favoritesLoading: false
      };
    case Types.DISMISS_FAVORITE_REPORT:
      return {
        ...state,
        favoriteReports: state.favoriteReports.map((item) => {
          if (item?.id === action.data?.reportId) {
            return { ...item, dismissed: true };
          }
          return item;
        })
      };
    case Types.UNDISMISS_FAVORITE_REPORT:
      return {
        ...state,
        favoriteReports: state.favoriteReports.map((item) => {
          if (item?.id === action.data?.reportId) {
            return { ...item, dismissed: false };
          }
          return item;
        })
      };
    case Types.GET_REPORT_BY_USER_ID_FAILURE:
      return {
        ...state,
        favoritesLoading: false
      };
    case Types.GET_FAVORITE_REPORT:
      return {
        ...state
      };
    case Types.GET_TOP_FAVORITE_REPORTS_REQUEST:
      return {
        ...state, 
        topFavoritesLoading: true
      };
    case Types.GET_TOP_FAVORITE_REPORTS_SUCCESS:
      return {
        ...state,
        topFavorites: action.data,
        topFavoritesLoading: false
      };
    case Types.GET_TOP_FAVORITE_REPORTS_FAILURE:
      return {
        ...state,
        topFavoritesLoading: false
      };
    case Types.SET_CURRENT_SELECTED_MENU:
      return {
        ...state,
        currentMenu: action.data
      };
    case Types.SET_STANDARD_SELECTED_TAGS:
      return {
        ...state,
        selectedLegacyTags: Array.isArray(action.data) ? action.data : []
      };
    default:
      return {
        ...state
      };
  }
}
